import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicensesRoutingModule } from './licenses-routing.module';
import { LicensesComponent } from './licenses.component';
import { DirectivesModule } from '../../directives/directives.module';
import { LicensesCreateComponent } from './components/licenses-create/licenses-create.component';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { LicensesService } from '../../services/licenses.service';

@NgModule({
  imports: [
    CommonModule,
    LicensesRoutingModule,
    DirectivesModule,
    AgGridModule.withComponents([
      BooleanCheckComponent
    ]),
    GridComponentsModule,
    FormsModule,
    Trip2ThemeModule
  ],
  providers: [
    LicensesService
  ],
  declarations: [LicensesComponent, LicensesCreateComponent]
})
export class LicensesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/licenses/licenses.module.ts